import {
  TableSkeletonLine,
  TableSkeletonRow,
  TableSkeletonWrapper
} from './BudgetTable.styles.ts'

export const BudgetTableSkeleton = () => (
  <TableSkeletonWrapper>
    {Array.from({ length: 6 }).map((_, index) => (
      <TableSkeletonRow key={index}>
        <TableSkeletonLine height={40} />
        <TableSkeletonLine height={40} />
        <TableSkeletonLine height={40} />
        <TableSkeletonLine height={40} />
        <TableSkeletonLine height={40} />
        <TableSkeletonLine height={40} />
      </TableSkeletonRow>
    ))}
  </TableSkeletonWrapper>
)
